<template>
    <div class="tool-container">
        <img  @click.stop="goBack()" src="~@/assets/images/a1.png" alt="">
        <span v-for="(item, index) in list" :class="{'now': index == list.length - 1}" :key="index" @click="goTo(item.url, index)">{{item.text}}<span v-if="index != list.length - 1">/</span></span>
    </div>
</template>

<script>
export default {
    methods: {
        goTo(url, i) {
            if (i === this.list.length - 1) {
                return
            }
            this.$router.replace(url)
        },
        goBack() {
            this.$router.back(-1)
            // let num = 0
            // if (this.list.length > 2) {
            //     num = this.list.length - 2
            // }
            // this.$router.replace(this.list[num].url)
        }
    },
    props: {
        list: {
            type: Array,
            /**
             * @param val 必须是这种格式，除了最后一个 [ { url: 'xxx', text: 'xxx' }, { text: 'xxx' } ]
             */
            validator(val) {
                const len = val.length
                return val.every((el, i) => {
                    if (Object.prototype.toString.call(el) !== '[object Object]') {
                        return false
                    }
                    if (i !== len - 1) {
                        return typeof el.url === 'string'
                    }
                    return true
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.tool-container {
    font-size: 14px;
    color: #999;
    letter-spacing: 0;
    line-height: 46px;
    user-select: none;

    img {
        margin-right: 5px;
        cursor: pointer;
    }

    span {
        padding: 2px;
        cursor: pointer;
    }

    > * {
        display: inline-block;
        vertical-align: middle;
    }

    .now {
        color: #333333;
    }
}
</style>
